import React from 'react';
import { CardWrapper } from './styles';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { compact } from 'lodash';

const FromToWarehouse = ({ data }: { data: DynamicObjectType }) => {
  const { t } = useTranslation();
  return (
    <CardWrapper
      title={
        <div className="flex justify-between items-center gap-2">
          <div className="w-full">{t('transferOrders.fromWarehouse')}</div>
          <div className="text-left w-full">
            {t('transferOrders.toWarehouse')}
          </div>
        </div>
      }
    >
      <div className="flex justify-between items-stretch gap-2">
        <div className="w-full">
          <div className="uppercase text-sm font-bold mb-[15px]">
            {data?.fromWarehouse?.name}
          </div>
          <div className="text-[#A6A6A6] text-sm">
            {/* 53a Lương Thế Vinh Quận Hải Châu Đà Nẵng */}
            {compact([
              data?.fromWarehouse?.addressLine,
              data?.fromWarehouse?.ward,
              data?.fromWarehouse?.district,
              data?.fromWarehouse?.province,
            ]).join(', ')}
          </div>
        </div>
        <div className="text-left w-full">
          <div className="uppercase text-sm font-bold mb-[15px]">
            {data?.toWarehouse?.name}
          </div>
          <div className="text-[#A6A6A6] text-sm">
            {compact([
              data?.toWarehouse?.addressLine,
              data?.toWarehouse?.ward,
              data?.toWarehouse?.district,
              data?.toWarehouse?.province,
            ]).join(', ')}
          </div>
        </div>
      </div>
    </CardWrapper>
  );
};

export default FromToWarehouse;
